import { render, staticRenderFns } from "./HelpCenterCreate.vue?vue&type=template&id=576769e7&"
import script from "./HelpCenterCreate.vue?vue&type=script&lang=js&"
export * from "./HelpCenterCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports